var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFlagyellow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 24,
    viewBox: "0 0 21 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3 1.5C3 0.670312 2.32969 0 1.5 0C0.670312 0 0 0.670312 0 1.5V3V17.25V22.5C0 23.3297 0.670312 24 1.5 24C2.32969 24 3 23.3297 3 22.5V16.5L6.01406 15.7453C7.94063 15.2625 9.97969 15.4875 11.7563 16.3734C13.8281 17.4094 16.2328 17.5359 18.3984 16.7203L20.025 16.1109C20.6109 15.8906 21 15.3328 21 14.7047V3.09375C21 2.01562 19.8656 1.3125 18.9 1.79531L18.45 2.02031C16.2797 3.10781 13.725 3.10781 11.5547 2.02031C9.90938 1.19531 8.02031 0.989063 6.23438 1.43438L3 2.25V1.5Z",
    fill: "#FFCD05"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFlagyellow);
export default __webpack_public_path__ + "static/media/flag yellow.bea9fc9c757fe6dafa19dac6d1a42808.svg";
export { ForwardRef as ReactComponent };